module.exports = __webpack_public_path__ + "img/tick.4351c1df.svg";